var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBtnYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.112,
    height: 139.105,
    viewBox: "0 0 139.112 139.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_188",
    x: 0,
    y: 0,
    width: 139.112,
    height: 139.105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.62
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_13",
    x: 36.723,
    y: 26.05,
    width: 78.698,
    height: 86.681,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Rectangle_188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188-2",
    "data-name": "Rectangle 188",
    width: 109.112,
    height: 109.105,
    rx: 54.552,
    transform: "translate(15 15)",
    fill: "#fa0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)",
    filter: "url(#Polygon_13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_13-2",
    "data-name": "Polygon 13",
    d: "M21.426,11.881a8,8,0,0,1,13.829,0L49.683,36.674A8,8,0,0,1,42.769,48.7H13.912A8,8,0,0,1,7,36.674Z",
    transform: "translate(100.42 41.05) rotate(90)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtnYellow);
export default __webpack_public_path__ + "static/media/playBtn_yellow.225be5bced71c8317130f2c05744c211.svg";
export { ForwardRef as ReactComponent };